import Section from "../Section/Section";
import { PROJECTS } from "../../../config/constants";
import Project from "./Project";
import SectionTitle from "../../common/SectionTitle";

export default function Projects() {
  return (
    <Section id="projects" className="w-full">
      <SectionTitle>Proyectos</SectionTitle>
      <div className="flex flex-col gap-4">
        {PROJECTS.map((project, index) => (
          <Project
            key={index}
            openSource={project.openSource}
            title={project.title}
            year={project.year}
            techs={project.techs}
            description={project.description}
            image={project.image}
            link={project.link}
          />
        ))}
      </div>
    </Section>
  );
}
